import { render, staticRenderFns } from "./performanceChart.vue?vue&type=template&id=b6a46cf6&"
import script from "./performanceChart.vue?vue&type=script&lang=js&"
export * from "./performanceChart.vue?vue&type=script&lang=js&"
import style0 from "./performanceChart.vue?vue&type=style&index=0&id=b6a46cf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports